import React from 'react';
import { Redirect } from 'react-router-dom';

export const ArticlesRedirect = React.memo(({ to }) => {
  return <Redirect to={`/articles/${to.slug}`} />;
});
